// @flow
import * as React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { IndexLink } from 'react-router';
import NineDotMenu from '../containers/NineDotMenu';
import logo from '../images/logo.png';
import logoUAT from '../images/logo-uat.png';
import type { User } from '../types';

class Header extends React.Component<*> {
  displayOrgName = (
    context: string,
    currentOrganisation: ?Object = {},
    currentLocation: ?Object = {}
  ) => {
    switch (context) {
      default:
      case 'global':
        return undefined;
      case 'customer':
        if (currentOrganisation && currentOrganisation.name) {
          return currentOrganisation.name;
        }
        return undefined;
      case 'sub-account':
        if (currentLocation && currentLocation.name) {
          return currentLocation.name;
        }
        return undefined;
    }
  };

  registrationTitle = (title: string, user: User) => {
    if (
      title === 'My Account' &&
      (!user.isEmailVerified || !user.isMobileVerified)
    ) {
      return 'Registration';
    }
    return title;
  };

  render() {
    const {
      currentOrganisation,
      currentLocation,
      params = {},
      routeContext,
      authentication = {},
      routeName
    } = this.props;
    const context = params.context || routeContext;

    const displayOrgName = this.displayOrgName(
      context,
      currentOrganisation,
      currentLocation
    );

    const logoSrc =
      process.env.REACT_APP_ENV === 'temp changed from just UAT'
        ? logoUAT
        : logo;

    return (
      // eslint-disable-next-line jsx-a11y/tabindex-no-positive
      <Navbar tabIndex="1">
        <Navbar.Header>
          <Navbar.Brand>
            <IndexLink to="/" aria-label="Back to Dashboard">
              <img src={logoSrc} className="logo" alt="logo" />
              <span className="hidden">{process.env.REACT_APP_ENV}</span>
            </IndexLink>
          </Navbar.Brand>
        </Navbar.Header>

        {authentication.isLoggedIn && (
          <div>
            <Navbar.Text className="page-title">
              {this.registrationTitle(routeName, authentication.user)}
              {displayOrgName && <span>For {displayOrgName}</span>}
            </Navbar.Text>

            <Nav pullRight>
              <NineDotMenu router={this.props.router} />
            </Nav>
          </div>
        )}

        {!authentication.isLoggedIn && (
          <Navbar.Text className="page-title">Campaign Targeter</Navbar.Text>
        )}
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js